export const shadowTypes = {
  CONTACT_SHADOW: 'contact-shadow',
  AI_SHADOW: 'ai-shadow',
};